"use client";
import React from "react";
import {
  Box,
  Center,
  Divider,
  Heading,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  VStack,
  Flex,
  SimpleGrid,
} from "@chakra-ui/react";
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";
import {PERFORMANCE_STORAGE_DATA} from "./constants";

export const DesktopView = () => {
  return (
    <TableContainer>
      <Table variant="striped" border={"2px solid rgb(237,242,247)"} width={"100%"}>
        <Thead>
          <Tr>
            <Th textAlign={"center"}>Storage</Th>
            <Th textAlign={"center"}>Outbound Transfer</Th>
            <Th textAlign={"center"}>Object / Cluster</Th>
            <Th textAlign={"center"}>Price / month</Th>
          </Tr>
        </Thead>
        <Tbody>
          {PERFORMANCE_STORAGE_DATA.map((item, index) => (
            <Tr key={index} fontSize={"15px"} color="#2d3748">
              <Td textAlign={"center"}>{item.storage}</Td>
              <Td textAlign={"center"}>{item.outbound}</Td>
              <Td textAlign={"center"}>{item.objectCluster}</Td>
              <Td textAlign={"center"}>
                <Text fontWeight={"700"} fontSize={"18px"} color="blue.600">
                  {item.price}
                </Text>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export const MobileView = () => {
  return (
    <SimpleGrid columns={{base: 1, sm: 2}} spacing={6}>
      {PERFORMANCE_STORAGE_DATA.map((item, index) => (
        <VStack
          key={index}
          borderRadius="lg"
          borderWidth="1px"
          borderColor="gray.200"
          boxShadow="md"
          spacing={3}
          w="100%"
          p={4}
          bg="white"
        >
          <Flex direction="column" align="center" w="full">
            <Box>
              <Text as="span" fontSize="lg">
                Storage : {""}
              </Text>
              <Text as="span" fontWeight="bold" fontSize="lg">
                {item.storage}
              </Text>
            </Box>
            <Divider borderColor="gray.200" my={2} w="60%" />
            <Text>Outbound Transfer: {item.outbound}</Text>
            <Text>Object / Cluster: {item.objectCluster}</Text>
            <Divider borderColor="gray.200" my={2} w="60%" />
            <Text fontWeight="bold" fontSize="xl" color="blue.600">
              {item.price}/mo
            </Text>
          </Flex>
        </VStack>
      ))}
    </SimpleGrid>
  );
};

const PerformanceStorageTable = () => {
  const HeadingVariant = useSectionHeadingVariant();
  return (
    <Box id="performance-object-storage">
      <Heading variant={HeadingVariant} textAlign={"center"} mb={4}>
        Performance Object Storage
      </Heading>

      <Center display={{md: "none"}} w="full">
        <MobileView />
      </Center>
      <Box display={{base: "none", md: "block"}}>
        <DesktopView />
      </Box>
      <Divider borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

export default PerformanceStorageTable;
